<template>
    <div class="d-flex flex-column">
        <div class="flex-fill text-center h4">
            <span>{{ date.format('YYYY-MM-DD') }}</span>
        </div>
        <div class="text-center mb-2">
            {{ batch.location.primary_company.name }} -
            {{ batch.therapist.user.name }} -
            {{ batch.location.address }} -
            {{ batch.location.city.name }}
        </div>
        <div class="mb-2">
            <button class="btn btn-outline-primary" @click="showAddScheduleModal()"><i class="fa fa-plus"></i> Lägg till tid</button>
            <button class="btn btn-outline-primary" @click="showSubstituteModal()"><i class="fa fa-user"></i> Tillsätt vikarie</button>
            <button class="btn btn-outline-primary" @click="showMessageModal()"><i class="fa fa-mail-forward"></i> Skicka meddelande</button>
            <button class="btn btn-outline-danger" @click="showUnbookDayModal()"><i class="fa fa-trash"></i> Avboka dag</button>
            <button class="btn btn-outline-danger" @click="showRemoveDayModal()"><i class="fa fa-trash"></i> Ta bort dag</button>
        </div>
        <div v-for="schedule in schedules" class="d-flex mb-2">
            <div class="rounded flex-fill p-2 d-flex justify-content-between border flex-column flex-md-row">
                <div class="col-md-5">
                    <div class="h5">
                        <span v-if="schedule.booking" class="text-success"><i class="fa fa-check" title="Tiden bokad"></i> </span>
                        <span v-else-if="schedule.preliminary_unbooking" class="text-warning"><i class="fa fa-times" title="Tiden preliminärt avbokad"></i></span>
                        <span v-else class="text-danger"><i class="fa fa-times" title="Tiden ledig"></i> </span>
                        {{ timespan(schedule.start, schedule.end) }}
                    </div>
                    <div>
                        <span v-if="bookingForSchedule(schedule)">{{ bookingForSchedule(schedule).treatment.name }}
                        </span>
                        <span v-else-if="schedule.treatments.length > 1" :title="getTreatmentsString(schedule)">{{ schedule.treatments.length }} behandlingar</span>
                        <span v-else>
                            {{ schedule.treatments[0] ? schedule.treatments[0].name : '-' }}
                        </span>
                        <div v-if="schedule.original_therapist_id && schedule.original_therapist_id != schedule.therapist_id" class="text-warning">
                            <i class="fa fa-user"></i> Vikarie <b>{{ schedule.therapist.user.name }}</b>
                        </div>
                    </div>
                </div>
                <div v-if="bookingForSchedule(schedule)" class="col-md mt-2 mt-md-0">
                    <template v-if="bookingForSchedule(schedule).user">
                        <div class="h5">{{ bookingForSchedule(schedule).user.name }}</div>
                        <div><a :href="'tel:'+bookingForSchedule(schedule).user.role.mobile">{{bookingForSchedule(schedule).user.role.mobile
                            }}</a></div>
                        <div><a :href="'mailto:'+bookingForSchedule(schedule).user.email">{{bookingForSchedule(schedule).user.email
                            }}</a></div>
                    </template>
                    <template v-else-if="bookingForSchedule(schedule).customer_name">
                        <div class="h5">{{ bookingForSchedule(schedule).customer_name }}</div>
                    </template>
                </div>
                <div v-else></div>
                <template v-if="! schedule.lock_id">
                    <div v-if="bookingForSchedule(schedule) && bookingForSchedule(schedule).user" class="d-flex flex-column justify-content-around mt-2 mt-md-0">
                        <button v-if="!bookingForSchedule(schedule).customer_missing" class="btn btn-sm btn-outline-success" @click="showCustomerAbsentModal(schedule)">
                            <i class="fa fa-user"></i>
                            {{ transEdit('present') }}
                        </button>
                        <button v-else class="btn btn-sm btn-outline-danger mt-2 mt-md-0" @click="showCustomerPresentModal(schedule)">
                            <i class="fa fa-user-times"></i>
                            {{ transEdit('absent') }}
                        </button>
                        <button class="btn btn-sm btn-outline-danger mt-2 mt-md-0" @click="showUnbookModal(schedule)">{{ transEdit('unbook') }}</button>
                    </div>
                    <div v-else-if="! bookingForSchedule(schedule)" class="d-flex flex-column justify-content-around mt-2 mt-md-0">
                        <button @click="showDeleteScheduleModal(schedule)" class="btn btn-sm btn-outline-danger"><i class="fa fa-trash"></i> {{ transEdit('remove') }}</button>
                        <button @click="showBookModal(schedule)" class="btn btn-sm btn-outline-primary mt-2"><i class="fa fa-plus"></i> {{ transEdit('book') }}</button>
                    </div>
                    <div v-else>
                        <button @click="showUnbookModal(schedule)" class="btn btn-sm btn-outline-danger"><i class="fa fa-trash"></i>
                            {{ transEdit('remove-post-registration') }}
                        </button>
                    </div>
                </template>
                <template v-else>
                    <div class="mt-2 mt-md-0">
                        <button class="btn btn-sm btn-link text-danger" disabled><i class="fa fa-lock"></i>
                            {{ transEdit('schedule-is-locked') }}
                        </button>
                    </div>
                </template>
            </div>
        </div>
        <template v-if="!loading && schedules && schedules.length > 0">
            <admin-schedules-modal-substitute :schedules="schedules"></admin-schedules-modal-substitute>
            <admin-schedules-modal-send-message :schedules="schedules"></admin-schedules-modal-send-message>
        </template>

    </div>
</template>
<script>
import RemoveSubstituteModal from '../AdminCalendar/RemoveSubstituteModal.vue'
import SubstituteModal from '../AdminCalendar/SubstituteModal.vue'
import SubstituteForDayModal from '../AdminCalendar/SubstituteForDayModal.vue'
import AdminSchedulesModalSendMessage from "./AdminSchedulesModalSendMessage";

export default {
    name: "AdminSchedulesList",
    components: {AdminSchedulesModalSendMessage},
    props: ['batch', 'filter_events_route', 'date'],
    data() {
        return {
            schedules: [],
            loading: true,
        }
    },
    watch: {
        batch() {
            this.getSchedules();
        }
    },
    computed: {
        ajaxUrl() {
            let formattedDate = this.date.format('Y-M-D');
            return this.filter_events_route + '?batch_id=' + this.batch.id + '&start_date=' + formattedDate + '&end_date=' + formattedDate;
        },
        tempsUrl() {
            let url = "/temp?";
            let isFirst = true;

            for (let i in this.schedules) {
                if (isFirst) {
                    isFirst = false;
                } else {
                    url += "&";
                }
                url += "schedules[]=" + this.schedules[i].id;
            }

            return url;
        }
    },
    methods: {
        bookingForSchedule(schedule) {
            return schedule.booking ? schedule.booking : schedule.preliminary_unbooking;
        },

        addTemps() {
            window.location = this.tempsUrl;
        },
        emptyList() {
            this.schedules = null;
        },
        getDateTime(dateString) {
            return moment(dateString).format('YYYY-MM-DD HH:mm')
        },
        getTime(dateString) {
            return moment(dateString).format('HH:mm')
        },
        getSchedules() {
            let self = this;
            axios.get(this.ajaxUrl)
                .then(function (res) {
                    self.schedules = res.data.events;
                    self.loading = false;
                })
                .catch(function (err) {
                });
        },
        selectTherapist(schedule) {
            this.selectedSchedule = schedule;
            this.$modal.show(SubstituteModal, {
                schedule: this.selectedSchedule
            }, {
                'width': '100%',
                'max-width': 800,
                'adaptive': true,
                'clickToClose': false,
            }, {
                'before-close': this.getSchedules
            })
        },
        removeSubstitute(schedule) {
            this.selectedSchedule = schedule;
            this.$modal.show(RemoveSubstituteModal, {
                schedule: this.selectedSchedule
            }, {
                'width': '100%',
                'max-width': 800,
                'adaptive': true,
                'clickToClose': false,
            }, {
                'before-close': this.getSchedules
            })
        },
        timespan: function (start, end) {
            let startDate = new Date(start);
            let endDate = new Date(end);

            let timespanString = startDate.getHrsMins() + " - " + endDate.getHrsMins();
            return timespanString;
        },
        showSubstituteModal: function () {
            let substituteModal = $("#substitute-modal");
            substituteModal.modal("show");
        },
        showMessageModal: function () {
            let messageModal = $("#send-message-modal");
            messageModal.modal("show");
        },
        showAddScheduleModal: function () {
            let addScheduleModal = $("#add-schedule-modal");
            let addScheduleModalDate = $("#add-schedule-modal-date");
            let addScheduleModalTherapistHidden = $("#add-schedule-modal-therapist-hidden");
            let addScheduleModalBatchId = $("#add-schedule-modal-batch-hidden");

            addScheduleModalBatchId.text(this.batch.id);
            addScheduleModalTherapistHidden.text(this.batch.therapist_id);
            addScheduleModalDate.text(this.date.format('YYYY-MM-DD'));
            addScheduleModal.modal("show");
        },
        showDeleteScheduleModal: function (schedule) {
            this.$emit('deleteSchedule', schedule);
        },
        showUnbookModal: function (schedule) {
            let unbookModal = $("#unbook-modal");

            let unbookModalDate = $("#unbook-modal-date");
            let unbookModalTime = $("#unbook-modal-time");
            let unbookModalId = $("#unbook-modal-id");

            let startDate = new Date(schedule.start);
            let endDate = new Date(schedule.end);
            let scheduleId = schedule.id;

            let dateString = startDate.getYMD();
            let timeString = startDate.getHrsMins() + " - " + endDate.getHrsMins();

            unbookModalDate.text(dateString);
            unbookModalTime.text(timeString);
            unbookModalId.val(scheduleId);

            unbookModal.modal('show');
        },
        showAbsenceModal() {
            let absenceModal = $("#absence-modal");
            let absenceModalDate = $("#absence-modal-date");
            let absenceModalBatchId = $("#absence-modal-batch-hidden");

            absenceModalBatchId.text(this.batch.id);
            absenceModalDate.text(this.date.format('YYYY-MM-DD'));
            absenceModal.modal("show");
        },
        showCustomerAbsentModal: function (schedule) {
            let customerAbsentModal = $("#customer-absent-modal");

            let customerAbsentModalDate = $("#customer-absent-modal-date");
            let customerAbsentModalTime = $("#customer-absent-modal-time");
            let customerAbsentModalId = $("#customer-absent-modal-id");
            let customerAbsentModalComment = $("#customer-absent-modal-comment");
            let customerAbsentModalCustomerName = $("#customer-absent-modal-customer-name");

            let startDate = new Date(schedule.start);
            let endDate = new Date(schedule.end);
            let bookingId = this.bookingForSchedule(schedule).id;
            let customer = this.bookingForSchedule(schedule).user.role;
            let user = this.bookingForSchedule(schedule).user;
            let customerName = "";

            if (user.name) {
                customerName = user.name;
            }

            let dateString = startDate.getYMD();
            let timeString = startDate.getHrsMins() + " - " + endDate.getHrsMins();

            customerAbsentModalDate.text(dateString);
            customerAbsentModalTime.text(timeString);
            customerAbsentModalCustomerName.text(customerName);
            customerAbsentModalId.val(bookingId);
            customerAbsentModalComment.val("");

            customerAbsentModal.modal('show');
        },
        showCustomerPresentModal: function (schedule) {
            let customerPresentModal = $("#customer-present-modal");

            let customerPresentModalDate = $("#customer-present-modal-date");
            let customerPresentModalTime = $("#customer-present-modal-time");
            let customerPresentModalId = $("#customer-present-modal-id");
            let customerPresentModalCustomerName = $("#customer-present-modal-customer-name");

            let startDate = new Date(schedule.start);
            let endDate = new Date(schedule.end);
            let bookingId = this.bookingForSchedule(schedule).id;
            let customer = this.bookingForSchedule(schedule).user.role;
            let user = this.bookingForSchedule(schedule).user;
            let customerName = "";

            if (user.name) {
                customerName = user.name;
            }

            let dateString = startDate.getYMD();
            let timeString = startDate.getHrsMins() + " - " + endDate.getHrsMins();

            customerPresentModalDate.text(dateString);
            customerPresentModalTime.text(timeString);
            customerPresentModalCustomerName.text(customerName);
            customerPresentModalId.val(bookingId);

            customerPresentModal.modal('show');
        },
        showRemoveDayModal: function () {
            let removeDayModal = $("#remove-day-modal");
            let removeDayModalDate = $("#remove-day-modal-date");
            let removeDayModalDateHidden = $("#remove-day-modal-date-hidden");
            let removeDayModalTherapistHidden = $("#remove-day-modal-therapist-hidden");
            let removeDayModalLocationHidden = $("#remove-day-modal-location-hidden");

            removeDayModalDate.text(this.date.format('YYYY-MM-DD'));
            removeDayModalDateHidden.text(this.date.format('YYYY-MM-DD'));
            removeDayModalTherapistHidden.text(this.batch.therapist_id);
            removeDayModalLocationHidden.text(this.batch.location_id);
            removeDayModal.modal("show");
        },
        showUnbookDayModal: function () {
            let unbookDayModal = $("#unbook-day-modal");
            let unbookDayModalDate = $("#unbook-day-modal-date");
            let unbookDayModalDateHidden = $("#unbook-day-modal-date-hidden");
            let unbookDayModalTherapistHidden = $("#unbook-day-modal-therapist-hidden");
            let unbookDayModalLocationHidden = $("#unbook-day-modal-location-hidden");

            unbookDayModalDate.text(this.date.format('YYYY-MM-DD'));
            unbookDayModalDateHidden.text(this.date.format('YYYY-MM-DD'));
            unbookDayModalTherapistHidden.text(this.batch.therapist_id);
            unbookDayModalLocationHidden.text(this.batch.location_id);
            unbookDayModal.modal("show");
        },
        showBookModal: function (schedule) {
            this.$emit('bookModal', schedule);
        }
    },
    mounted() {
        this.getSchedules();
    }
}
</script>

<style scoped>

.schedule-slot {
    display: flex;
    justify-content: space-between;
}

.text-small {
    font-size: 0.6em;
}

</style>
